import { render, staticRenderFns } from "./hero.html?vue&type=template&id=b93bcee2&scoped=true&"
import script from "./hero.js?vue&type=script&lang=js&"
export * from "./hero.js?vue&type=script&lang=js&"
import style0 from "./hero.scss?vue&type=style&index=0&id=b93bcee2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93bcee2",
  null
  
)

export default component.exports